// Shared event lifecycle status → style map.
// Single source of truth used by GameEvent (status pill) and Dashboard (CC overview indicator).
export const eventStatusTag = {
  draft:        { background: 'rgba(154,166,176,.08)', color: '#9aa6b0', border: '1px solid rgba(154,166,176,.3)' },
  prep:         { background: 'rgba(255,204,51,.08)',  color: '#ffcc33', border: '1px solid rgba(255,204,51,.3)' },
  registration: { background: 'rgba(255,122,24,.08)',  color: '#ff7a18', border: '1px solid rgba(255,122,24,.3)' },
  locked:       { background: 'rgba(77,160,255,.08)',  color: '#4da0ff', border: '1px solid rgba(77,160,255,.3)' },
  live:         { background: 'rgba(255,42,42,.12)',   color: '#ff2a2a', border: '1px solid rgba(255,42,42,.4)' },
  endex:        { background: 'rgba(179,128,255,.10)', color: '#b380ff', border: '1px solid rgba(179,128,255,.35)' },
  closed:       { background: 'rgba(0,255,102,.04)',   color: '#2a6a3a', border: '1px solid rgba(0,255,102,.12)' },
  cancelled:    { background: 'rgba(154,166,176,.06)', color: '#6a7480', border: '1px solid rgba(154,166,176,.2)' },
}

// Label helper — matches the GameEvent pill convention (● LIVE for running state).
export function eventStatusLabel(status) {
  return status === 'live' ? '● LIVE' : (status || 'draft').toUpperCase()
}
